import { Navigate, useLocation } from 'react-router-dom'
import Login from '../../pages/Auth/Login'
import { RouteObject } from 'react-router'
import { AuthPageLayout } from '../../pages/Auth/AuthPageLayout'
import User from '../../pages/User'
import { LogoutPage } from '../../pages/Auth/LogoutPage'
import { BuffetLinePage } from '../../pages/BuffetLinePage/BuffetLinePage'

import { MilletPage } from '../../pages/TaresPage/MilletPage'
import { CreateMilletPage } from '../../pages/TaresPage/CreateMilletPage'
import { CategoriesPage } from '../../pages/CategoriesPage/CategoriesPage'
import { OptionsPage } from '../../pages/OptionsPage/OptionsPage'
import { PlanMenuPage } from '../../pages/PlanMenuPage/PlanMenuPage'
import { CreatePlanMenuPage } from '../../pages/PlanMenuPage/CreatePlanMenuPage'
import { PlanMenuTypePage } from '../../pages/PlanMenuTypePage/PlanMenuTypePage'
import { TemplatePlanMenuPage } from '../../pages/TemplatePlanMenuPage/TemplatePlanMenuPage'
import { CreateTemplatePlanMenuPage } from '../../pages/TemplatePlanMenuPage/CreateTemplatePlanMenuPage'
import { TagsPage } from '../../pages/TagsPage/TagsPage'
import { PlanMenuControlAdmin } from '../../pages/PlanMenuControl/PlanMenuControlAdmin'
import { PlanMenuClosePage } from '../../pages/PlanMenuClosePage/PlanMenuClosePage'
import { PlanMenuControlManager } from '../../pages/PlanMenuControl/PlanMenuControlManager'
import { PlanMenuControlManagerDetail } from '../../pages/PlanMenuControl/PlanMenuControlManagerDetail'
import { Role } from '../api/dto/UserDto'
import { burgerDataBuffetLineByRole } from '../../pages/BuffetLinePage/components/HeaderBuffetLinePage'
import { BuffetComparativeReports } from '../../pages/BuffetComparativeReports/BuffetComparativeReports'
import { BuffetComparativeReportsDetail } from '../../pages/BuffetComparativeReports/BuffetComparativeReportsDetail'
import { AllRoutes } from './AllRoutes'
import { BuffetReportsVZ } from 'pages/BuffetReportsVZPage/BuffetReportsVZ'
import { BuffetReportsVZLine } from 'pages/BuffetReportsVZPage/BuffetReportsVZLine'
import { BuffetReportsVZChart } from 'pages/BuffetReportsVZPage/BuffetReportVZChart'
import { GuestTypePage } from 'pages/GuestTypePage/GuestTypePage'
import { DishesPage } from 'pages/DishesPage/DishesPage'
import { CreateDishPage } from 'pages/DishesPage/CreateDishPage'
import { TypeMismatchPage } from 'pages/TypeMismatch/TypeMismatchPage'
import BuffetReportsBI from 'pages/BuffetReportsVZPage/BuffetReportsBI'

interface IRedirect {
  path?: string
}

export const AppRedirect = ({ path = '/' }: IRedirect) => {
  const location = useLocation()
  return <Navigate to={path} state={{ from: location }} replace />
}

export const loginRoutes: RouteObject = {
  path: '/',
  element: <AuthPageLayout />,
  children: [
    { index: true, element: <Login /> },
    {
      path: AllRoutes.login.path,
      element: <Login />,
    },
    { path: '*', element: <Login /> },
  ],
}

const buffetLineRoutes = {
  path: '/',
  element: <BuffetLinePage />,
  children: [
    {
      index: true,
      element: <Navigate to={AllRoutes.dishes.path} replace />,
    },
    {
      id: '1',
      path: AllRoutes.dishes.path,
      children: [
        {
          index: true,
          element: <DishesPage />,
        },
        {
          path: AllRoutes.addDishes.path,
          element: <CreateDishPage />,
        },
        {
          path: AllRoutes.editDishes.path,
          element: <CreateDishPage />,
        },
      ],
    },
    {
      id: '2',
      path: AllRoutes.categories.path,
      element: <CategoriesPage />,
    },
    {
      id: '3',
      path: AllRoutes.millet.path,
      children: [
        { index: true, element: <MilletPage /> },
        { path: AllRoutes.addMillet.path, element: <CreateMilletPage /> },
        { path: AllRoutes.editMillet.path, element: <CreateMilletPage /> },
      ],
    },
    {
      id: '4',
      path: AllRoutes.templatePlanMenu.path,
      children: [
        {
          index: true,
          element: <TemplatePlanMenuPage />,
        },
        {
          path: AllRoutes.addTemplatePlanMenu.path,
          element: <CreateTemplatePlanMenuPage />,
        },
        {
          path: AllRoutes.editTemplatePlanMenu.path,
          element: <CreateTemplatePlanMenuPage />,
        },
      ],
    },
    {
      id: '5',
      path: AllRoutes.planMenuType.path,
      element: <PlanMenuTypePage />,
    },
    {
      id: '24',
      path: AllRoutes.typeMismatch.path,
      element: <TypeMismatchPage />,
    },
    {
      id: '6',
      path: AllRoutes.planMenu.path,
      children: [
        {
          index: true,
          element: <PlanMenuPage />,
        },
        {
          path: AllRoutes.addPlanMenu.path,
          element: <CreatePlanMenuPage />,
        },
        {
          path: AllRoutes.editPlanMenu.path,
          element: <CreatePlanMenuPage />,
        },
      ],
    },
    {
      id: '15',
      path: AllRoutes.buffetComparativeReports.path,
      children: [
        { index: true, element: <BuffetComparativeReports /> },
        {
          path: AllRoutes.buffetComparativeReportsDetail.path,
          element: <BuffetComparativeReportsDetail />,
        },
      ],
    },
    {
      id: '9',
      path: AllRoutes.planMenuControl.path,
      element: <PlanMenuControlAdmin />,
    },
    {
      id: '10',
      path: AllRoutes.planMenuControlManager.path,
      children: [
        { index: true, element: <PlanMenuControlManager /> },
        {
          path: AllRoutes.planMenuControlManagerDetail.path,
          element: <PlanMenuControlManagerDetail />,
        },
      ],
    },
    {
      id: '11',
      path: AllRoutes.planMenuClose.path,
      element: <PlanMenuClosePage />,
    },
    {
      id: '12',
      path: AllRoutes.tags.path,
      element: <TagsPage />,
    },
    {
      id: '19',
      path: AllRoutes.options.path,
      element: <OptionsPage />,
    },
    {
      id: '14',
      path: AllRoutes.guestType.path,
      element: <GuestTypePage />,
    },
    {
      path: `${AllRoutes.user.path}`,
      element: <User />,
    },
    {
      id: '20',
      path: `${AllRoutes.logout.path}`,
      element: <LogoutPage />,
    },
    {
      id: '21',
      path: '*',
      element: <AppRedirect path="/" />,
    },
    {
      id: '23',
      path: AllRoutes.buffetReportsVZ.path,
      children: [
        { index: true, element: <BuffetReportsVZ /> },
        {
          path: AllRoutes.buffetReportsVZLine.path,
          element: <BuffetReportsVZLine />,
        },
        {
          path: AllRoutes.buffetReportsVZChart.path,
          element: <BuffetReportsVZChart />,
        },
        {
          path: AllRoutes.buffetReportsBi.path,
          element: <BuffetReportsBI />,
        },
      ],
    },
  ],
}

const routeFilterByRole = (role: Role) => {
  const routes = buffetLineRoutes.children.filter((child) =>
    burgerDataBuffetLineByRole[role].some(
      (item: number) => `${item}` === `${child.id}`,
    ),
  )
  return routes
}

export const appRoutes = {
  authorized: [
    {
      role: Role.COOK,
      routes: [
        ...routeFilterByRole(Role.COOK),
        {
          id: '9',
          path: AllRoutes.planMenuControl.path,
          element: <PlanMenuControlAdmin />,
        },
      ],
    },
    {
      role: Role.ACCOUNTANT,
      routes: [
        ...routeFilterByRole(Role.ACCOUNTANT),
        {
          id: '9',
          path: AllRoutes.planMenuControl.path,
          element: <PlanMenuControlAdmin />,
        },
      ],
    },
    {
      role: Role.SUPERVISOR,
      routes: routeFilterByRole(Role.SUPERVISOR),
    },
    {
      role: Role.ADMINISTRATOR,
      routes: routeFilterByRole(Role.ADMINISTRATOR),
    },
    {
      role: Role.CONTROLLER,
      routes: routeFilterByRole(Role.CONTROLLER),
    },
    {
      role: Role.MANAGER,
      routes: routeFilterByRole(Role.MANAGER),
    },
  ],
  notAuthorized: [
    {
      ...loginRoutes,
      path: '/',
    },
  ],
}
